// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9226d24e","977":"9b866d7e"}[chunkId] + ".chunk.js";
};